import React, { useEffect, useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import classNames from 'classnames';

import { setTitle } from '~main/actions/login';

export interface Tab {
  id: string;
  title: string;
  component: React.FC<any>;
  authTag?: string;
}

interface ComponentProps {
  tabs: Tab[];
  className?: string;
}

const TabContainer: React.FC<ComponentProps> = ({ tabs, className }) => {
  const [activeTab, setActiveTab] = useState<number>(0);

  const navClassNames = (tabId: number) => classNames({ active: activeTab === tabId });

  const buildNavTabs = () => {
    return tabs.map(({ id, title }, index) => (
      <NavItem key={index}>
        <NavLink data-cy={`${id}-tab`} className={navClassNames(index)} onClick={() => setActiveTab(index)}>
          {title}
        </NavLink>
      </NavItem>
    ));
  };

  const buildTabsContent = () => {
    return tabs.map(({ component, title, authTag }, index) => {
      const Component = component;

      return (
        <TabPane key={index} tabId={index}>
          <Component isActive={activeTab === index} title={title} authTag={authTag} />
        </TabPane>
      );
    });
  };

  const outerClassName = classNames('p-2 tab-container', className);

  useEffect(() => {
    setTitle(tabs[activeTab].title);
  }, [activeTab]);

  return (
    <div className={outerClassName}>
      <Nav tabs>{buildNavTabs()}</Nav>
      <TabContent className="p-2" activeTab={activeTab}>
        {buildTabsContent()}
      </TabContent>
    </div>
  );
};

export default TabContainer;
